/**
 * What a patient signs up to when they choose LillyDirect ordering.
 *
 * Kept in one place because it has to appear identically wherever the offer is
 * presented, and because enforcing a commitment the patient was never shown is
 * indefensible. If these change, bump the version: consent is recorded against
 * it so it stays clear what each patient actually agreed to.
 *
 * See tasks/lillydirect-two-tier/08-engagement-check-ins.md
 */
export const LILLYDIRECT_TERMS_VERSION = "2026-08-25";

export const LILLYDIRECT_COMMITMENTS = [
  "Order roughly every four weeks, so your treatment continues without a gap.",
  "Check in with our Weight Management Service every two weeks to log your weight and tell us about any side effects.",
  "Continued access to LillyDirect pricing depends on keeping up that contact.",
];

export const LILLYDIRECT_BENEFITS = [
  "Lower cost on every dose.",
  "Free home delivery, supplied and delivered directly by LillyDirect.",
  "Ongoing clinical support, so side effects are picked up early.",
];
